import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState({
    orders: (count: number) => translate({ id: 'global.counter.orders', values: { count } }),
  })

  return api
}
